export default __webpack_public_path__ + "static/media/step_C_EN.4de6428f.png";